import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "search",
      placeholder: "Search...",
      class: "form-control filter-search"
    })
  ])
], -1)
const _hoisted_2 = { class: "row searchable" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 search-no-results" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "alert alert-warning" }, " No results found. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HtmlMeta = _resolveComponent("HtmlMeta")!
  const _component_ExtensionPanel = _resolveComponent("ExtensionPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HtmlMeta, {
      title: "n3t Joomla! Extensions",
      description: "Joomla! plugins, modules and components by n3t.",
      image: require('@/assets/opengraph.png'),
      url: "https://n3t.bitbucket.io",
      schema: _ctx.schema()
    }, null, 8, ["image", "schema"]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.extensions, (extension) => {
        return (_openBlock(), _createBlock(_component_ExtensionPanel, {
          key: extension,
          name: extension
        }, null, 8, ["name"]))
      }), 128)),
      _hoisted_3
    ])
  ], 64))
}